import React, { useState, useEffect, createRef, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
// import logo from "../../assets/images/buscar-logo-light.png";
import logo from "../../assets/images/tcr-logo-light.png";
import { api, userLogin } from "../../api";
import { validateEmail } from "../../utils/validate";
import { useIntl } from "react-intl";
import UserContext from "../../context/UserContext";
import { useAmbient } from "../../hooks/ambient";

const Login = () => {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorType, setErrorType] = useState('');
  const { formatMessage: f } = useIntl();

  let emailInput = createRef();

  const { setAmbient } = useAmbient();
  const userData = useContext(UserContext);

  useEffect(() => {
    emailInput.current && emailInput.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleResendValidationMail = () => {
    setIsLoading(true);
    api.post('/users/resend_validation_mail', {
      email
    })
      .then(res => {
        setIsLoading(false);
      })
  }

  const handleLoginSubmit = e => {
    e.preventDefault();
    if (email.length === 0 || password.length === 0) {
      let errorFields = "";
      if (email.length === 0) errorFields += "e-mail";
      if (password.length === 0) {
        if (errorFields.length > 0) errorFields += ", ";
        errorFields += f({ id: "senha" }).toLocaleLowerCase();
      }

      setErrorMessage(`${f({ id: "informe" })} ${errorFields}`);
    } else if (!validateEmail(email)) {
      setErrorMessage(f({ id: "email-invalido" }));
    } else {
      setIsLoading(true);
      userLogin(email, password)
        .then(res => {
          localStorage.setItem("access_token", res.data.token);
          setIsLoading(false);
          userData.setLoggedIn();
          setAmbient(res.data.ambiente);
          history.push("/");
        })
        .catch(error => {
          setErrorType(error.response.data.type);
          setErrorMessage(error.response.data.message || f({ id: "erro-api" }));
          setIsLoading(false);
          console.log("Error object:", error);
          console.log("Error response:", error.response);
          console.log("Error data:", error.response.data);
        });

    }
  };

  return (
    <>
      <div className="logo">
        <a href = "/">
          <img alt="BusCAR logo" src={logo} />
        </a>
      </div>
      {errorMessage ? (
        <div className="auth-error-message" data-testid="error">
          {errorMessage} 
          {errorType === 'email-nao-validado' && (
            <a href="#/" onClick={handleResendValidationMail}>
              &nbsp;Gerar novo e-mail de validação.
            </a>
          )}
        </div>
      ) : (
        <div className="auth-error-message-spacer" data-testid="error"></div>
      )}

      <div className="input-container">
        <input
          ref={emailInput}
          type="email"
          name="email"
          placeholder="E-mail"
          value={email}
          required
          onChange={e => setEmail(e.target.value)}
          data-testid="email-input"
        />
        <label htmlFor="email">E-mail</label>
      </div>

      <div className="input-container">
        <input
          type="password"
          name="password"
          placeholder={f({ id: "senha" })}
          value={password}
          required
          onChange={e => setPassword(e.target.value)}
          data-testid="password"
        />
        <label htmlFor="password">{f({ id: "senha" })}</label>
      </div>

      <button
        className={`button primary ${isLoading ? "is-loading" : ""}`}
        onClick={handleLoginSubmit}
      >
        {f({ id: "entrar" })}
      </button>
      <div className="links">
        {/* <Link to="/signup_fail">{f({ id: "cadastre-se" })}</Link> |{" "} */}
        <Link to="/forgot_password">{f({ id: "redefinir-senha" })}</Link>
      </div>
    </>
  );
};

export default Login;
